module.exports = __webpack_public_path__ + "static/media/gps_location.50a1a700.png";